import { render, staticRenderFns } from "./UnassignedComplaint.vue?vue&type=template&id=5fb99c14&"
import script from "./UnassignedComplaint.vue?vue&type=script&lang=js&"
export * from "./UnassignedComplaint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports